<template>
  <div>
    <v-card outlined>
      <v-card-title class="title">
        {{ $tt('customBillingAddNewCard') }}
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="6">
              <label>{{ $tt('customCreditCardNameOnCard') }}</label>
              <v-text-field
                :error-messages="stripeCardNameErrors"
                @input="$v.stripeCardName.$touch()"
                class="aid-stripe-text-input"
                placeholder="TARO YAMADA"
                required
                solo
                v-model="stripeCardName"
              />
            </v-col>
            <v-col cols="12" md="6">
              <label>{{ $tt('customCreditCardInfo') }}</label>
              <card
                :options="stripeOptions"
                :stripe="getStripeKey()"
                @change="stripeCardComplete = $event.complete"
                class="stripe-element stripe-card pa-3 elevation-2"
                ref="stripeCardElement"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!stripeCardComplete"
          @click="addCard()"
          class="white--text text-none"
          color="primary"
          v-if="hasFreeFunctionality()"
        >
          カードを設定
        </v-btn>
        <v-btn :disabled="!stripeCardComplete" @click="addCard()" class="white--text text-none" color="primary" v-else>
          {{ $tt('customCreditCardAddCard') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <now-loading-overlay-component :nowLoading="nowLoading" />
  </div>
</template>

<script>
import StripeInfo from '@/lib/stripe-info'
import Toast from '@/lib/toast'
import { Card, createToken } from 'vue-stripe-elements-plus'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import NowLoadingOverlayComponent from '@/components/NowLoadingOverlayComponent'
import UserInfo from '@/lib/user-info'

export default {
  name: 'AddCreditCardComponent',
  components: { Card, NowLoadingOverlayComponent },
  data() {
    return {
      stripeCardName: null,
      stripeCardComplete: false,
      nowLoading: false,
      stripeOptions: { hidePostalCode: true },
    }
  },
  props: {
    isChangePaymentMethodType: Boolean,
    default: false
  },
  methods: {
    hasFreeFunctionality() {
      return UserInfo.hasFreeFunctionality()
    },
    getStripeKey() {
      return StripeInfo.getPublishableKey()
    },
    addCard() {
      this.$v.$touch()
      if (this.$v.error) {
        console.error('Validation Error')
        return
      }
      this.nowLoading = true
      createToken({ name: this.stripeCardName })
        .then(data => {
          if (data.error) {
            console.error(data.error)
            this.closeNowLoading()
            Toast.error(data.error.message)
          } else {
            const stripeTokenObject = data.token
            const params = {
              stripeToken: stripeTokenObject.id,
              stripeCardName: this.stripeCardName,
              onSuccess: this.onAddCardSuccess,
              onFailure: this.onAddCardFailure,
            }
            if (UserInfo.hasFreeFunctionality()) {
              // フリーの場合はサブスクリプション開始の時に同時に設定する
              const addCardRequest = { stripeToken: params.stripeToken, stripeCardName: params.stripeCardName }
              this.$emit('setStripeAddCardRequest', addCardRequest)
              this.closeNowLoading()
            } else if (this.isChangePaymentMethodType) {
              const addCardRequest = { stripeToken: params.stripeToken, stripeCardName: params.stripeCardName }
              this.$emit('changePaymentMethodToCard', addCardRequest)
              this.closeNowLoading()
            } else {
              this.$store.dispatch('addStripeCreditCard', params)
            }
          }
        })
        .catch(error => {
          console.error(error)
          this.closeNowLoading()
        })
    },
    onAddCardSuccess() {
      this.$refs.stripeCardElement.clear()
      this.stripeCardName = null
      this.$v.$reset()
      this.nowLoading = false
      this.$emit('success')
    },
    onAddCardFailure(errorResponse) {
      this.closeNowLoading()
      Toast.error(errorResponse.data.message)
      console.error(errorResponse)
      this.$emit('failed')
    },
    closeNowLoading() {
      this.nowLoading = false
    },
  },
  computed: {
    stripeCardNameErrors() {
      const errors = []
      if (!this.$v.stripeCardName.$dirty) return errors
      !this.$v.stripeCardName.required && errors.push(this.$tt('ValidationTextRequired'))
      return errors
    },
  },
  mixins: [validationMixin],
  validations: {
    stripeCardName: { required },
  },
}
</script>
<style scoped>
.stripe-card.complete {
  border-color: green;
}
</style>
